import type { Filter } from '../types/filter.type.js';

// stores all implemented filters, see
// available filters for reference
export const SUPPORTED_FILTERS = new Map<string, Filter>();
